import React from "react";
import Iframe from "react-iframe";
import { globalStore } from "../../Global/GlobalContext/GlobalContext";
import { kycStore } from "../KycContext/KycContext";
import "./ExternalKycProviderIFrameForm.scss";

export default function ExternalKycProviderIFrameForm() {
  const { kycState, advanceKyc, appInsightsTrackEvent } =
    React.useContext(kycStore);
  const { isMobile } = React.useContext(globalStore);

  document?.getElementById("iframePlaceToScroll")?.scrollIntoView();

  React.useEffect(() => {
    listenToAriadnextEvents();
    listenToStarbyteEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kycState]);

  const isAriadnextEvent = (event: any) => {
    if (event.data?.idcheckio) {
      return true;
    }
    return false;
  };

  function listenToAriadnextEvents() {
    const listener = (event: any) => {
      if (
        !import.meta.env.VITE_KYC_CALLBACK_ORIGIN_HOST_LIST?.split(
          ";"
        ).includes(event.origin)
      ) {
        appInsightsTrackEvent({
          name: "ExternalKycProviderIFrameForm event from other origin received",
          properties: {
            event: event,
            eventOrigin: event.origin,
            allowedOrigin: import.meta.env.VITE_KYC_CALLBACK_ORIGIN_HOST_LIST,
          },
        });
        return;
      }

      if (!isAriadnextEvent(event)) {
        return;
      }

      appInsightsTrackEvent({
        name: "ExternalKycProviderIFrameForm event received from iframe",
        properties: {
          event: event,
          eventData: event.data,
          eventOrigin: event.origin,
        },
      });

      if (event.data?.idcheckio?.event !== "ENDED") {
        appInsightsTrackEvent({
          name: "ExternalKycProviderIFrameForm event received from iframe - data.idcheckio.event not ENDED. returning",
          properties: {
            event: event,
            eventData: event.data,
          },
        });
        return;
      }

      advanceKyc();
    };

    window.addEventListener("message", listener);

    return () => {
      window.removeEventListener("message", listener);
    };
  }

  function listenToStarbyteEvents() {
    const listener = (event: any) => {
      if (isAriadnextEvent(event)) {
        return;
      }

      appInsightsTrackEvent({
        name: "ExternalKycProviderIFrameForm event received from iframe",
        properties: {
          event: event,
          eventData: event.data,
          eventOrigin: event.origin,
        },
      });

      if (
        !import.meta.env.VITE_KYC_CALLBACK_ORIGIN_HOST_LIST?.split(
          ";"
        ).includes(event.origin)
      ) {
        appInsightsTrackEvent({
          name: "ExternalKycProviderIFrameForm event from other origin received",
          properties: {
            event: event,
            eventOrigin: event.origin,
            allowedOrigin: import.meta.env.VITE_KYC_CALLBACK_ORIGIN_HOST_LIST,
          },
        });
        return;
      }

      if (event.data.info !== "OK") {
        appInsightsTrackEvent({
          name: "ExternalKycProviderIFrameForm event received from iframe - data.info not ok. returning",
          properties: {
            event: event,
            eventData: event.data,
          },
        });
        return;
      }

      advanceKyc();
    };

    window.addEventListener("message", listener);

    return () => {
      window.removeEventListener("message", listener);
    };
  }
  const iframeUrl = kycState.kycProviderUrls?.[kycState.currentForm] || "";

  return (
    <React.Fragment>
      <div className="kyc-form-white">
        <Iframe
          id="iframePlaceToScroll"
          src={iframeUrl}
          frameBorder={0}
          url={iframeUrl}
          className={isMobile ? "iframe_mobile" : "iframe_desktop"}
          allow="camera"
        />
      </div>
    </React.Fragment>
  );
}
